import { Box, Typography, useTheme } from '@mui/material';
import CroppModal from 'shared/lib/components/modals/croppModal';
import UploadArea, {
  UploadedReadedFile,
} from 'shared/lib/components/controls/uploadArea/uploadArea';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { t } from 'i18next';
import IconFolder from 'shared/icons/iconFolder';
import IconTrash from 'shared/icons/trash';
import { UploadedFileOrString } from 'shared/lib/utils/uploadedFileOrString';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function UploadImageControl({
  image,
  onRemove,
  onUpload,
  error,
  fieldName = 'Изображение',
  isCroppDisabled = false,
  accept,
}: {
  image: UploadedFileOrString | null;
  onRemove: () => void;
  onUpload: (file: UploadedReadedFile) => void;
  error?: boolean;
  fieldName?: string;
  isCroppDisabled?: boolean;
  accept?: Record<string, string[]>;
}) {
  const { t } = useTranslation();
  const {
    spacings: { sp },
  } = useContext(UiContext);
  const theme = useTheme();

  const [beforeCropp, setBeforeCropp] = useState<null | UploadedReadedFile>(
    null
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: sp.s50,
        width: 1,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: sp.s20,
          width: 1,
        }}
      >
        <Typography variant="f20">{fieldName}</Typography>
        <UploadArea
          isDataUrl
          accept={accept}
          error={error}
          handleAddFile={(uf) => {
            onUpload(uf);
            setBeforeCropp(uf);
          }}
          areMultipleUploadsAllowed={false}
          text={t('noCategory.uploadFileHelp')}
          icon={
            <IconFolder
              sizeKey="48x48"
              extColor={theme.palette.text.secondary}
            />
          }
        ></UploadArea>
      </Box>

      {beforeCropp && !isCroppDisabled ? (
        <CroppModal
          isOpen={true}
          handleClose={() => setBeforeCropp(null)}
          src={beforeCropp.dataUrl}
          type={beforeCropp.originalFile.type}
          name={beforeCropp.originalFile.name}
          onApply={(uploadedFile) => {
            onUpload(uploadedFile);
          }}
        ></CroppModal>
      ) : (
        ''
      )}

      {image && (
        <Box
          sx={{
            display: 'flex',
            width: 1,
            alignItems: 'center',
            gap: sp.s20,
          }}
        >
          <img style={{ height: 40, width: 40 }} alt="" src={image.src}></img>
          <Typography
            sx={{ textOverflow: 'ellipsis', overflow: 'hidden', width: 1 }}
          >
            {image.file?.name}
          </Typography>
          <IconTrash
            isAutoscallable={false}
            extColor={theme.palette.error.main}
            onClick={onRemove}
          ></IconTrash>
        </Box>
      )}
    </Box>
  );
}
